import ApiService from "@/services/Api"

import { WABAAppData, WABAUsageSummary } from "@/@integrations/WABA/protocols/channel"
import { DefaultWhereDataType } from "@/utils/pagination"
import { AppWabaInfo, AppWabaInfoReturn, GetWabaAppEventsHistoryResponse, GetWabaAppEventsHistoryReturn } from "@/@integrations/WABA/protocols/wabaAccountInfo"

class WABAChannelService {
	async getAppData (channelId?: number): Promise<WABAAppData> {
		const result = await ApiService.get(`/waba/channel/${channelId}/app-data`)

		return result.data
	}

	async getWabaAppInfo (inboxChannelId: number): Promise<AppWabaInfo> {
		const result = await ApiService.get<AppWabaInfoReturn>(`/waba/channel/${inboxChannelId}/app/info`)

		return result.data.appInfo
	}

	async getWabaAppEventsHistory (inboxChannelId: number, pagination: DefaultWhereDataType): Promise<GetWabaAppEventsHistoryResponse> {
		const result = await ApiService.get<GetWabaAppEventsHistoryReturn>(`/waba/channel/${inboxChannelId}/app/events-history`, {
			params: {
				page: pagination.page + 1,
				rowsPerPage: pagination.rowsPerPage
			}
		})

		return {
			events: result.data.events,
			totalRows: result.data.totalRows || result.data.events.length
		}
	}

	async getUsage (channelId: number, from: string, to: string): Promise<WABAUsageSummary> {
		const { data } = await ApiService.get<WABAUsageSummary>(`/waba/channel/${channelId}/usage`, {
			params: { from, to }
		})
		return data
	}

	async reconnectChannel (inboxChannelId: number): Promise<void> {
		await ApiService.post(`/waba/channel/${inboxChannelId}/reconnect`)
	}

	async disconnectChannel (inboxChannelId: number): Promise<void> {
		await ApiService.post(`/waba/channel/${inboxChannelId}/disconnect`)
	}
}

export default new WABAChannelService()
